/**
 * @license
 * Copyright 2023 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */

import {AssistChip} from './assist-chip.js';

/**
 * A suggestion chip component.
 */
export class SuggestionChip extends AssistChip {}

// Note: assist and suggestion chips are functionally identical with different
// tokens.
